import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api from '../utils/api';
import SortableTable from "../utils/SortableTable";

const InviteDetails = () => {
  const { inviteId } = useParams();
  const [invite, setInvite] = useState(null);
  const [rsvps, setRsvps] = useState([]);

  useEffect(() => {
    api.get(`/invites/${inviteId}/rsvps`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      },
      withCredentials: true
    }).then(res => {
      setInvite(res.data.invite);
      console.log("📦 Invite Data:", res.data.invite);
      setRsvps(res.data.rsvps);
    }).catch(err => {
      console.error("❌ Failed to load RSVPs:", err);
    });
  }, [inviteId]);

  const getStatusLabel = (response) => {
    switch (response) {
      case 1:
        return (
          <>
            <i className="fa-solid fa-check text-approve" /> Yes
          </>
        );
      case 2:
        return (
          <>
            <i className="fa-solid fa-xmark text-decline" /> No
          </>
        );
      default:
        return (
          <>
            <i className="fa-solid fa-hourglass-half text-await" /> No Response
          </>
        );
    }
  };
  
  const getStatusClass = (response) => {
    switch (response) {
      case 1:
        return "status-approve";
      case 2:
        return "status-decline";
      default:
        return "status-await";
    }
  };

  function formatDateRange(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const sameDay = startDate.toDateString() === endDate.toDateString();

    const dateOptions = { month: 'short', day: 'numeric', year: 'numeric' };
    const timeOptions = { hour: 'numeric', minute: '2-digit' };

    if (sameDay) {
      return `${startDate.toLocaleDateString(undefined, dateOptions)} · ${startDate.toLocaleTimeString(undefined, timeOptions)} – ${endDate.toLocaleTimeString(undefined, timeOptions)}`;
    } else {
      return `${startDate.toLocaleDateString(undefined, dateOptions)} ${startDate.toLocaleTimeString(undefined, timeOptions)} – ${endDate.toLocaleDateString(undefined, dateOptions)} ${endDate.toLocaleTimeString(undefined, timeOptions)}`;
    }
  }

  const isEventOver = (endDate) => {
    return new Date(endDate) < new Date();
  };

  const columns = [
    { label: "Name", title: "Name", key: "name", width: "40" },
    { label: "Email", title: "Email", key: "email", width: "40" },
    { label: "Status", title: "Name", key: "response", width: "20" },
    { label: "", title: "Actions", key: "actions", width: "10" }
  ];

  const [editMode, setEditMode] = useState(false);

  const [recipients, setRecipients] = useState([{ name: "", email: "" }]);

  const updateRecipient = (index, field, value) => {
    setRecipients((prev) =>
      prev.map((r, i) => (i === index ? { ...r, [field]: value } : r))
    );
  };

  const addRecipientField = () => {
    setRecipients((prev) => [...prev, { name: "", email: "" }]);
  };

  const removeRecipient = (index) => {
    setRecipients((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddRecipients = async () => {
    if (!recipients.every(r => r.name.trim() && r.email.trim())) {
      alert("Please fill out all name and email fields.");
      return;
    }

    try {
      await api.post(`/invites/${inviteId}/add_recipients`, recipients, {
        headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` }
      });
      setRecipients([{ name: "", email: "" }]);
      const res = await api.get(`/invites/${inviteId}/rsvps`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` }
      });
      setInvite(res.data.invite);
      setRsvps(res.data.rsvps);
      setEditMode(false);
    } catch (err) {
      console.error("❌ Failed to add recipients", err);
    }
  };

  const handleRemoveRecipient = async (email) => {
    try {
      await api.post(
        `/invites/${inviteId}/remove_recipient`,
        { email },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json" // ✅ add this
          }
        }
      );
      setRsvps(rsvps.filter(r => r.email !== email));
    } catch (err) {
      console.error("❌ Failed to remove recipient", err);
    }
  };

  return (
    <div className="container invite">
      <h2>{invite?.title}</h2>
      <h3>{invite?.location} <span style={{ float: "right" }}>{formatDateRange(invite?.start, invite?.end)}</span></h3>

      <div className="rsvp-invite-preview">
        <div dangerouslySetInnerHTML={{ __html: invite?.message }} />
      </div>

      {invite?.flyer_url && (
        <div className="flyer-preview">
          <img
            src={invite.flyer_url.startsWith("http") ? invite.flyer_url : `http://localhost:8008${invite.flyer_url}`}
            alt="Flyer"
            style={{ maxWidth: "100%", marginBottom: "1rem", borderRadius: "8px" }}
          />
        </div>
      )}

      <h3><i className="instavite-orange fa-solid fa-list-check"></i> RSVP Responses 
        <button
          type="button"
          className="simple-link header-btn-right"
          onClick={() => setEditMode(!editMode)}
          disabled={isEventOver(invite?.end)}
          title={isEventOver(invite?.end) ? "This event has already ended" : ""}
        >
          {editMode ? "Cancel" : "Add/Edit Recipients"}
        </button>
      </h3>

      {editMode && (
        <div className="rsvp-form" style={{ marginBottom: "1rem" }}>
          {recipients.map((r, idx) => (
            <div key={idx} className="recipientDiv">
              <input
                placeholder="Name"
                name={`Name_${idx}`}
                value={r.name}
                onChange={(e) => updateRecipient(idx, "name", e.target.value)}
                required
              />
              <input
                placeholder="Email"
                name={`Email_${idx}`}
                value={r.email}
                onChange={(e) => updateRecipient(idx, "email", e.target.value)}
                required
              />
              {recipients.length > 1 ? (
                idx > 0 ? (
                  <button
                    className="simple-btn"
                    type="button"
                    onClick={() => removeRecipient(idx)}
                  >
                    <i className="fa-solid fa-xl fa-xmark text-decline" />
                  </button>
                ) : (
                  <button className="simple-btn placeholder" type="button">
                    <i className="fa-solid fa-xl fa-xmark text-decline" />
                  </button>
                )
              ) : null}
            </div>
          ))}

    <div className="footer-btns">
      <button type="button" className="simple-link" onClick={addRecipientField}>
        <i className="fa-solid fa-plus" /> Add Another
      </button>

      <button type="button" onClick={handleAddRecipients}>
        Submit Recipients
      </button>
    </div>
  </div>
)}


      {rsvps.length === 0 ? (
        <p>No responses yet.</p>
      ) : (
        <SortableTable
          columns={columns}
          data={rsvps}
          renderRow={(rsvp, idx) => (
            <tr key={idx}>
              <td width="40">{rsvp.name}</td>
              <td width="40">{rsvp.email}</td>
              <td width="20" className={getStatusClass(rsvp.response)}>
                {getStatusLabel(rsvp.response)}
              </td>
              <td width="10">
                {editMode && rsvp.response === 0 ? (
                  <button
                    className="btn btn-link text-danger"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (window.confirm(`Remove ${rsvp.name} (${rsvp.email}) from this invite?`)) {
                        handleRemoveRecipient(rsvp.email);
                      }
                    }}
                  >
                    <i className="fa-solid fa-trash" />
                  </button>
                ) : (
                  <span className="text-muted"><i className="fa-solid fa-lock" /></span>
                )}
              </td>
            </tr>
          )}
        />
      )}
    </div>
  );
};

export default InviteDetails;
